module.exports = __webpack_public_path__ + "static/media/calendar-2.6bb90547.svg";